/**
 * The ONE display formatter for org-settings taxonomy tags (document types, contact
 * types, contact roles) — 7/28 Part A5.
 *
 * Christophe's rule: org settings is the standard for how a tag is formatted everywhere.
 * Sentence case, first letter capitalized, no underscores — INCLUDING the locked system
 * built-ins. Every surface that renders a tag (org-settings editor, contact badges, the
 * portal document tag, dropdowns) runs its value through this so the wording is identical
 * on both sides (client profile ↔ portal) and never leaks a raw slug.
 *
 * It is deliberately conservative: a value that already carries capitalization (a proper
 * label like "Notice of Value" or "Tax Bill") is preserved verbatim (minus underscores),
 * so we never mangle "Notice of Value" into "Notice Of Value". Only an all-lowercase slug
 * (e.g. "client_rep") is title-cased → "Client Rep".
 */
export function formatTagLabel(value: string | null | undefined): string {
  if (!value) return '';
  const spaced = String(value).replace(/_+/g, ' ').trim();
  if (!spaced) return '';
  // Already has an uppercase letter → an authored label; keep its casing (underscores gone).
  if (/[A-Z]/.test(spaced)) return spaced;
  // All-lowercase slug → Title Case each word.
  return spaced.replace(/\b\w/g, (c) => c.toUpperCase());
}
